import React from 'react';

import { Panel } from './Panel/Panel';
import { Card } from './Card/Card';
import { Collapse } from './Collapse/Collapse';
import { PanelsSection, PanelsHeader, PanelsTitle, PanelsCardSection, PanelsContainer } from './Panels.style';
import { IPanelProps } from './Panels.i';

export const Panels = ({ className, title='', items, button, type='pane', background, count=4 }: IPanelProps) => {
  const getType = (list: string[], lowercase = false) => {
    if(list && list.includes('news')) {
      return lowercase ? 'news' : 'News';
    } else if(list && list.includes('video')) {
      return lowercase ? 'video' : 'Video';
    } else {
      return lowercase ? 'riac-blog' : 'Blog';
    }
  };

  return (
    <React.Fragment>
      {(type === 'pane' || type === 'post')
        && <PanelsSection className = {className}>
          <PanelsHeader>
            {title && <PanelsTitle>{title}</PanelsTitle>}
            {button}
          </PanelsHeader>
          {items && items.map((item, key: number) => {
            return (
              <React.Fragment key={key}>
                {key < count
                  && <Panel
                    key={key}
                    image={item?.image?.replace('.com/ghost/', '.com/ghost/size/w600/') || ''}
                    type={type === 'post' ? getType(item?.tags || []) : ''}
                    title={typeof item.title === 'string' ? item.title : item.title[0]}
                    content={item.content}
                    posts={type === 'post'}
                    to={item.slug}
                    button={item.button}
                  />
                }
              </React.Fragment>
            );}
          )}
        </PanelsSection>
      }
      {(type === 'card' || type === 'collapse')
        && <PanelsCardSection className = {className} background={background}>
          <PanelsHeader>
            {title && <PanelsTitle>{title}</PanelsTitle>}
            {button}
          </PanelsHeader>
          <PanelsContainer>
            {(type === 'card' && items) && items.map((item, key: number) => (
              <Card
                key={key}
                image={item.image}
                title={item.title}
                content={item.content}
                navigation={item.navigation}
              />
            ))}
            {(type === 'collapse' && items) && items.map((item, key: number) => (
              <Collapse
                key={key}
                image={item.image}
                title={item.title}
                content={item.content}
              />
            ))}
          </PanelsContainer>
        </PanelsCardSection>
      }
    </React.Fragment>
  );
};
